/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CitationReviewRequest = {
  /**
   * accept => status 'accepted'; dismiss => soft, reversible status 'dismissed' (the row is kept).
   */
  action: CitationReviewRequest.action;
};
export namespace CitationReviewRequest {
  /**
   * accept => status 'accepted'; dismiss => soft, reversible status 'dismissed' (the row is kept).
   */
  export enum action {
    ACCEPT = 'accept',
    DISMISS = 'dismiss',
  }
}

